/**
 * react-i18next bootstrap — initializes with EMPTY resources so main.js
 * stays lean. Actual locale bundles are loaded on demand via loadLocale()
 * and added with i18n.addResourceBundle() from I18nContext.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { defaultLang, supportedLangs } from "./loadTranslations";

const STORAGE_KEY = "prombiz_lang";

function initialLng() {
  if (typeof window === "undefined") return defaultLang;
  const seg = window.location.pathname.split("/")[1];
  if (supportedLangs.includes(seg)) return seg;
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && supportedLangs.includes(stored)) return stored;
  const br = navigator.language?.split("-")[0];
  if (br && supportedLangs.includes(br)) return br;
  return defaultLang;
}

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    // Start with empty resources — locale bundles are added dynamically
    resources: { [defaultLang]: { translation: {} } },
    lng: initialLng(),
    fallbackLng: defaultLang,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    // Until the locale bundle finishes loading, show the key instead of empty
    parseMissingKeyHandler: (key) => key,
  });
}

export default i18n;
export { STORAGE_KEY };
